interface DAO_CONFIG {
    minimumSamoQty: number,
    minimumNftQty: number
}
export const DAO_CONFIG:DAO_CONFIG = {
    minimumSamoQty: 100000,
    minimumNftQty: 1
}